import React, { useMemo } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { allowedImageTypes } from 'src/view/components/Controls/Upload/constants';
import { IFile } from 'src/view/components/Controls/Upload/types';
import Upload from 'src/view/components/Controls/Upload/Upload';
import Text, { TEXT } from 'src/view/components/Text/Text';
import './style.scss';

interface IProps {
  image: string | undefined;
  addMode?: boolean;
  validation?: boolean;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  onChange: (file: IFile) => void;
  uploadImage: (image: string) => void;
}

const ItemImageUpload: React.FC<IProps> = (props: IProps): JSX.Element => {
  const uploadClassName = useMemo((): string => {
    let className: string = 'item-image-upload__wrapper';

    if (props.addMode) className += ' item-image-upload__wrapper_add-mode';
    if (!props.validation) className += ' input-error';

    return className;
  }, [props.addMode, props.validation]);

  return (
    <div className={`d-flex flex-column ${props.className || ''}`}>
      <Upload
        image={props.image}
        onChange={props.onChange}
        changeFile={props.uploadImage}
        initialAspectRatio={15 / 10}
        allowedFileTypes={allowedImageTypes}
        maxFileSize={512000} // 500 kb
        className={uploadClassName}
        disabled={props.disabled}
        smallValidationBlock>
        {props.addMode ? (
          <div className={`item-image-upload__btn-add mr-4 ${props.disabled ? 'item-image-upload__btn-add_disabled' : ''}`}>
            <Icon name={Icons.Plus} size={14} color={theme.colors.mainblue} />
          </div>
        ) : (
          <div className="item-image-upload d-flex flex-row align-items-center justify-content-center full-width">
            <div className="item-image-upload__container mr-3">
              <span className="item-image-upload__square item-image-upload__square_blue"></span>
              <span className="item-image-upload__square item-image-upload__square_gray"></span>
              <Icon className="item-image-upload__icon" name={Icons.Hand} color={theme.colors.gray2} />
            </div>
            <div className="d-flex flex-column">
              <p className="family-regular text-size-16 color-dark required">{localeStore.t('upload_image')}</p>
              <p className="family-regular text-size-10 color-gray2 mt-2">{localeStore.t('item_img_requirements')}</p>
            </div>
          </div>
        )}
      </Upload>
      {props.required ? <Text type={TEXT.ERROR} text="item_img_requirements" /> : null}
    </div>
  );
};

export default ItemImageUpload;
